import ITransferenciaTmovPayRequestDTO from '../entities/ITransferenciaTmovPayRequestDTO'
import ITransferenciaTmovPayResponseDTO from '../entities/ITransferenciaTmovPayResponse'
import { IPagamentoRepository } from '../repositories/IPagamentoRepository'

export interface ITransferenciaTmovPay {
  execute(
    data: ITransferenciaTmovPayRequestDTO,
  ): Promise<ITransferenciaTmovPayResponseDTO>
}

export default class TransferenciaTmovPayImpl implements ITransferenciaTmovPay {
  constructor(private readonly pagamentoRepository: IPagamentoRepository) {}
  async execute(
    data: ITransferenciaTmovPayRequestDTO,
  ): Promise<ITransferenciaTmovPayResponseDTO> {
    return this.pagamentoRepository.transferToTmovPay(data)
  }
}
